/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import {
  TextField,
  ColorField,
  YouTubeUrlField,
  ModeSelect,
  ArticlesByTagField,
  ArticlesByEventField,
  PositionField,
} from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';
import { IMAGE_SIZE } from '@api/media/constants';

import Form from '../Form';

import { MODE, MODES, detectMode, CAROUSEL_FIELDS } from './constant';

const HeroSlidesForm = ({ onSubmit, initialValues: initData, buttons, className, isUltimateDesign }) => {
  const carouselFields = CAROUSEL_FIELDS;
  if (isUltimateDesign) {
    carouselFields.SLIDER_TEXT_POSITION.rules = [];
    carouselFields.SLIDE_TEXT_COLOR.rules = [];
    carouselFields.SLIDE_IMAGE.size = IMAGE_SIZE['600x400'];
  }
  const [form] = Form.useForm(carouselFields);

  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const [mode, setMode] = React.useState(detectMode(initialValues).value);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  const handleSelectMode = React.useCallback(
    (_mode) => {
      setMode(_mode);
      form.resetFields([carouselFields.SLIDE_ARTICLE.name]);
    },
    [form],
  );

  return (
    <Form
      form={form}
      onSerializedFinish={handleFinish}
      labelAlign="left"
      layout="vertical"
      colon={false}
      initialValues={initialValues}
      className={className}
    >
      {buttons && <Typography.Text level={3}>Edit Slide</Typography.Text>}
      <ModeSelect
        mode={mode}
        onSelect={handleSelectMode}
        {...MODE}
        labelCol={{ span: 3 }}
        style={{ flexDirection: 'row', display: buttons ? 'none' : undefined }}
      />
      <Row>
        {mode === MODES.EXISTING.value && <ArticlesByEventField {...carouselFields.SLIDE_ARTICLE} isTypeFilter />}
        <Col flex="1" offset={mode !== MODES.TAG.value && !buttons && 3}>
          {mode === MODES.TAG.value && <ArticlesByTagField {...carouselFields.SLIDE_ARTICLE} />}
          {mode === MODES.MANUAL.value && (
            <Row>
              <Col flex="1">
                <TextField {...carouselFields.SLIDE_LOCATION} rules={null} />
                <MediaField {...carouselFields.SLIDE_IMAGE} />
                <TextField {...carouselFields.SLIDE_TITLE} />
                <TextField {...carouselFields.SLIDE_SUBTITLE} rules={null} />
                {!isUltimateDesign && <TextField {...carouselFields.SLIDE_STANDFIRST} rules={null} />}
              </Col>
            </Row>
          )}
          {mode === MODES.VIDEO.value && (
            <Row>
              <Col flex="1">
                <YouTubeUrlField {...carouselFields.SLIDE_VIDEO} />
                <MediaField {...carouselFields.SLIDE_IMAGE} />
                <TextField {...carouselFields.SLIDE_TITLE} />
                <TextField {...carouselFields.SLIDE_SUBTITLE} />
                <TextField {...carouselFields.SLIDE_STANDFIRST} />
              </Col>
            </Row>
          )}
          <Row>
            <Col flex="1">
              {isUltimateDesign && <TextField {...carouselFields.CTA_TEXT} />}
              {!isUltimateDesign && (
                <Row gutter={40}>
                  <Col span={8}>
                    <PositionField {...carouselFields.SLIDER_TEXT_POSITION} />
                  </Col>
                  <Col>
                    <ColorField {...carouselFields.SLIDE_TEXT_COLOR} />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD SLIDE
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default HeroSlidesForm;
